var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-suffix"},[_vm._t("default"),(_vm.isIcon)?_c('Icon',{staticClass:"suffix",attrs:{"name":_vm.suffix,"color":"secondary-400"}}):_c('span',{staticClass:"suffix"},[_vm._v(" "+_vm._s(_vm.suffix)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }